// Avatar pose enum for type safety
export enum AvatarPose {
  ThumbsUpOpenMouth = 'pose-thumbs-up-open-mouth-big-smile-excited-eyes-raised-brows',
  PowerStanceSubtleSmile = 'pose-power-stance-subtle-smile-raised-outer-brows-confident',
  OpenMouthBigSmile = 'pose-open-mouth-big-smile-excited-eyes-closed-raised-inner-brows',
  PowerStanceOpenMouth = 'pose-power-stance-open-mouth-big-smile-excited-raised-brows',
  ThumbsUpWink = 'pose-thumbs-up-smile-wink-right-eye-excited-look',
  DefaultPortrait = 'pose-fullbody-portrait-smile-raised-inner-brows',
}

// Feedback poses used for random feedback animations (all poses except default)
export const FEEDBACK_AVATAR_POSES = Object.values(AvatarPose).filter((pose) => pose !== AvatarPose.DefaultPortrait)

export default function randomFeedback(): {
  avatarPose: string
  avatarMessage: { text: string; size: string }
} {
  const avatarMessage = [
    { text: 'great', size: 'text-xl md:text-h2' },
    { text: 'awesome', size: 'text-md md:text-h4' },
    { text: 'impressive', size: 'text-sm md:text-h4' },
    { text: 'cool', size: 'text-xl md:text-h2' },
    { text: 'amazing', size: 'text-md md:text-h4' },
    { text: 'nice', size: 'text-xl md:text-h2' },
  ]

  const randomPose = Math.floor(Math.random() * FEEDBACK_AVATAR_POSES.length)
  const randomMessage = Math.floor(Math.random() * avatarMessage.length)

  return { avatarPose: FEEDBACK_AVATAR_POSES[randomPose], avatarMessage: avatarMessage[randomMessage] }
}
